import React, { Component, PropTypes  } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from '../actions'
import LoginValidationForm from '../components/profile/LoginValidationForm'
import { browserHistory } from 'react-router'
import cookie from 'react-cookie'
import { api, domen } from '../config.js'
import Modal from 'boron/FadeModal'
import CSSModules from 'react-css-modules'
import styles from './profileLogin.css'
import LoadingView from '../components/componentKit/LoadingView'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}
/**
 *  Компонент ProfileLogin.
 *  Используется для отображения страницы 'Логин' (/)
 *
 */
class ProfileLogin extends Component {
  /**
   * @memberof ProfileLogin
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {func} propTypes.setToken Установка токена
   *
   * */
  static propTypes = {
    /**
     * Функция для выбора дня
     * @memberof ProfileLogin
     * @param {string} token - Токен
     */
    setToken: PropTypes.func.isRequired
  }
  state = {
    isLoad:false
  }

  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.margin = '100px'
      contentStyle.width = '300px'
    }
  }
  componentDidMount() {
    window.onload = () => {
      console.log('onloaddd22')
      this.setState({
        isLoad: true
      })
    };
  }

  render () {
    const { setToken, sign } = this.props
    const isAlfa = domen.isAlfa

    if(!this.state.isLoad){
      return (<LoadingView title="Загружается..."/>)
    }

    return (
      <div>
        <LoginValidationForm sign={sign} onSubmit={ data => {
          this.refs.loadingModal.show()
          return fetch(`${api}/user/authenticate`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(data)
          })
          .then(response => response.json())
          .then(json => {
              console.log(json)
            console.log('profileloginnn')
            this.refs.loadingModal.hide()
            if (json.data && json.errorCode === 1 && json.data.paidState !== 0) {
              window.carrotquest.auth(json.data.id, json.data.cqhmac)
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              setToken(json.data.authToken)

              cookie.save('userProgram', json.data.program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              cookie.save('fullName', json.data.firstName + ' ' + json.data.lastName, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })

              if (json.data.paidState === 2 && (json.data.program % 4 !== 0)) {
                browserHistory.push('/signup/pay/success')
              } else if (json.data.paidState === 2 && (json.data.program % 4 === 0)) {
                browserHistory.push('/signup/pay/friend?simple=true')
              } else if (json.data.isFirstEdit) {
                console.log('prrrrrrrr')
                browserHistory.push('/profile')
              } else {
                console.log('ttttttt')
                browserHistory.push('/task')
                //browserHistory.push('/signup/pay/success')
              }
            } else if (json.data && json.data.paidState !== 0 && (json.data.program === 12 || json.data.program === 16)) {
              window.carrotquest.auth(json.data.id, json.data.cqhmac)
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              browserHistory.push('/signup/pay/friend?simple=true')
            } else if (json.data && !json.data.program) {
              window.carrotquest.auth(json.data.id, json.data.cqhmac)
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              browserHistory.push('/signup/pay/success')
              //browserHistory.push('/profile')
            } else if (json.data && (!isAlfa && (json.data.paidState === 0 || json.data.paidState === 1))) {
              window.carrotquest.auth(json.data.id, json.data.cqhmac)
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              browserHistory.push('/signup/pay')
            } else if (json.data && isAlfa && json.data.paidState === 0){
              cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
              browserHistory.push('/signup/pay/success')
            } else if (json.data && isAlfa && json.data.paidState === 1){
              browserHistory.push('/task')
              //browserHistory.push('/signup/pay/success')
            } else {
              this.refs.errorModal.show()

            }
          })
        }}/>

        <Modal ref='loadingModal' contentStyle={contentStyle} backdrop={false}>
          <div className={styles.entryHeader}>
            <h2 className={styles.entryTitleCenter}>Загружается...</h2>
          </div>
          <div className={styles.textCenter}>
            <div className={styles.loaderMain}></div>
          </div>
        </Modal>
        <Modal ref='errorModal' contentStyle={contentStyle}>
          <h2>Неправильный email или пароль</h2>
          <br/>
          <button className={styles.buttonAction} onClick={() => this.refs.errorModal.hide()}>
            Продолжить
          </button>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  profile: state.profile,
  sign: state.sign
})

const mapDispatchToProps = dispatch => ({
  showError: bindActionCreators(actions.createProfile, dispatch),
  setToken: bindActionCreators(actions.setToken, dispatch)
})

ProfileLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileLogin)

export default CSSModules(ProfileLogin, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/containers/ProfileLogin.js